export default __webpack_public_path__ + "static/media/Danni 9781408300282.10c24ead.jpg";